export function shouldBlockPortraitGameplay(runActive: boolean, hasVisiblePanel: boolean): boolean {
  return runActive && !hasVisiblePanel;
}

export function resolveReducedEffects(
  systemPreference: boolean,
  savedPreference: boolean,
): boolean {
  return systemPreference || savedPreference;
}

export function effectParticleCount(requested: number, reducedEffects: boolean): number {
  return reducedEffects ? Math.min(6, Math.max(0, requested)) : Math.max(0, requested);
}
